import VerificationInput from "react-verification-input";

export default function Disable2FA({ data: code, setData: setCode }) {
  return (
    <div className="row row-sm google-auth">
      <div className="form-group mg-t-15 col-m-6">
        <div
          className="store-update-btn"
          id="2faForm"
        >
          <div className="mm-number-Auth">
            <div className="mm-number-container">
              <div className="mm-number-input">
                <div className="mm-number-input-container animated">
                  <VerificationInput
                    type="text"
                    value={code.one_time_password}
                    onChange={(value) =>
                      setCode({
                        ...code,
                        one_time_password: value,
                      })
                    }
                    placeholder="."
                    autoFocus
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
